import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { HistogramApiService } from './histogram.api.service';
import { HistogramData } from '../../models/histogramData';

@Injectable()
export class HistogramDomainService {
    constructor(private histogramApiService: HistogramApiService) { }

    getHistogram(jobId: string, date: Date, bin: number): Observable<{} | HistogramData> {
        return this.histogramApiService.getHistogram(jobId, date, bin);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/histogram/histogram.domain.service.ts